function headers(options) {
  const withDefaults = options || {}
  const nextHeaders = { ...(withDefaults.headers || {}) }
  nextHeaders['X-Requested-With'] = 'XMLHttpRequest'
  return {
    ...withDefaults,
    headers: nextHeaders,
  }
}

export function fetch(url, options) {
  return window.fetch(url, headers(options))
}

function appendFormData(formData, key, value) {
  if (Array.isArray(value)) {
    value.forEach((item, index) => {
      appendFormData(formData, `${key}[${index}]`, item)
    })
    return
  }

  if (value && typeof value === 'object' && !(value instanceof Date) && !(value instanceof File)) {
    Object.keys(value).forEach((subKey) => {
      appendFormData(formData, `${key}[${subKey}]`, value[subKey])
    })
    return
  }

  if (value === undefined) {
    return
  }

  formData.append(key, value === null ? '' : value)
}

export async function postFormData(url, payload, options = {}) {
  const formData = new FormData()

  Object.keys(payload || {}).forEach((key) => {
    appendFormData(formData, key, payload[key])
  })

  const response = await fetch(url, {
    ...options,
    method: 'POST',
    body: formData,
  })

  if (!response.ok) {
    throw new Error(`Request failed (${response.status})`)
  }

  try {
    return await response.json()
  } catch (error) {
    throw new Error('Invalid server response.')
  }
}
